<loading-creating-site *ngIf="loading"></loading-creating-site>
<div *ngIf="!loading" class="wrapper-stepper">
    <div class="upper-bar">
        <h2>
            <button class="btn btn-link" style="color: white; font-size: inherit !important" cdkStepperPrevious>
                <i class="far fa-chevron-left" style="cursor: pointer"></i>
            </button>
            {{ 'app.wizard.upper_bar.previsualizacion' | translate }}
        </h2>
    </div>
    <div class="py-5 px-4 w-100 step-container">
        <div class="info-container">
            <div class="title-template">
                <h2
                    class="color-secundario mb-3"
                    [innerHTML]="'app.wizard.stepper_ia.previsualizar-titulo' | translate"
                ></h2>
                <p class="subtitle-content color-texto2 sub-title">
                    {{ 'app.wizard.stepper_ia.esta_es_la_paleta' | translate }}
                </p>
            </div>
            <div class="mb-4 iframe-container">
                <div class="iframe-layout">
                    <div class="iframe-section">
                        <div class="iframe-browser-bar">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                        <div class="iframe-holder">
                            <div class="iframe-scaler">
                                <iframe
                                    #marketIframe
                                    [src]="iframeUrl | safe"
                                    sandbox="allow-forms allow-scripts allow-same-origin"
                                    name="myiFrame"
                                    width="1280"
                                    height="720"
                                    allowfullscreen
                                ></iframe>
                                <div class="iframe-overlay"></div>
                            </div>
                        </div>
                    </div>

                    <div class="options-panel">
                        <p class="subtitle-content color-texto2 sub-title">
                            {{ 'app.wizard.stepper_ia.personaliza-los-colores' | translate }}
                        </p>
                        <div
                            class="theme-card main-theme-card mb-3"
                            [ngClass]="{ 'theme-card-selected': customTheme?.id == selectedTheme }"
                            (click)="reloadIframe(customTheme, true)"
                        >
                            <div class="theme-title">{{ customTheme?.name | uppercase }}</div>
                            <div class="theme-bar">
                                <div
                                    class="bar-header"
                                    [ngStyle]="{ 'background-color': customTheme?.header.color }"
                                ></div>
                                <div
                                    class="bar-footer"
                                    [ngStyle]="{ 'background-color': customTheme?.footer.color }"
                                ></div>
                                <div
                                    class="bar-primary"
                                    [ngStyle]="{ 'background-color': customTheme?.content.primary_color }"
                                ></div>
                                <div
                                    class="bar-secondary"
                                    [ngStyle]="{ 'background-color': customTheme?.content.secondary_color }"
                                ></div>
                            </div>
                            <button class="edit-btn" (click)="onEditTheme()" aria-label="Editar">
                                <i class="fas fa-pen"></i>
                            </button>
                        </div>
                        <p class="subtitle-content color-texto2 sub-title">
                            {{ 'app.wizard.stepper_ia.proba-otro-estilo' | translate }}
                        </p>
                        <div class="themes-container" *ngIf="themes$ | async">
                            <div
                                *ngFor="let theme of themes$ | async"
                                class="theme-card"
                                [ngClass]="{ 'theme-card-selected': theme?.id == selectedTheme }"
                                (click)="reloadIframe(theme, false)"
                            >
                                <div class="theme-title">{{ theme?.name | uppercase }}</div>
                                <div class="theme-bar">
                                    <div
                                        class="bar-header"
                                        [ngStyle]="{ 'background-color': theme?.header_color }"
                                    ></div>
                                    <div
                                        class="bar-footer"
                                        [ngStyle]="{ 'background-color': theme?.footer_color }"
                                    ></div>
                                    <div
                                        class="bar-primary"
                                        [ngStyle]="{ 'background-color': theme?.primary_color }"
                                    ></div>
                                    <div
                                        class="bar-secondary"
                                        [ngStyle]="{ 'background-color': theme?.secondary_color }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="btn-div px-4">
        <!-- <button class="btn btn-link color-link back-btn" cdkStepperPrevious>
            <i class="fas fa-chevron-left mr-1"></i>{{ 'app.global.modals.volver' | translate }}
        </button> -->
        <div class="h-100">
            <button (click)="onFormSubmit()" class="btn btn-continue">
                <i class="fas fa-sparkles"></i>
                {{ 'app.global.modals.finalizar' | translate }}
            </button>
        </div>
    </div>
</div>
